import {connect, useSelector} from "react-redux";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {CAlert, CButton, CCol, CForm, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {Loading} from "../../../components/common";
import {AgGridReact} from "ag-grid-react";
import StoreListWhere from "../where/StoreListWhere";
import {getCkProductInfoOne, getCkProductListNation, getCommonCodeGroup, insertCkProductInfo} from "../../../api/api";
import * as api from "../../../api/api";
import StoreCornerListWhere from "../where/StoreCornerListWhere";
import {currencyFormatter} from "../../../config/formatter";

const ProductLanguage = (props) => {
    const {user} = useSelector((props) => props.account);

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]);
    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", cornerCd: ""
    });
    const [selectProduct, setSelectProduct] = useState({});
    const [selectNationCd, setSelectNationCd] = useState("US");
    const [selectProductInfo, setSelectProductInfo] = useState({seq:0, productNm: "", origin: "", nutrient: "", nationCd: "US"});

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "seq", headerName: "seq", hide:true},
        {field: "restProductCd", headerName: "상품코드", width: 130},
        {field: "productNm", headerName: "상품명"},
        {field: "price", headerName: "판매단가", minWidth: 100, valueFormatter: currencyFormatter},
        {field: "nationNm", headerName: "등록언어", width: 100}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    const search = async () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd} = props.selected;
        if (storeCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 매장은 반드시 선택하셔야 합니다."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn: 'Y',
            productNm: searchForm.productNm,
            restProductCd: searchForm.restProductCd
        };

        setLoading(true);
        getCkProductListNation(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log(">>> response :: ", responseBody);
                // 성공
                setGridData(responseBody);
            }
        })
            .finally(() => {
                setLoading(false);
            })
    };

    const save = async () => {
        if (confirm("저장하시겠습니까?")) {
            // 저장 파라메터 생성
            const productInfo = {
                ...selectProductInfo,
                cmpCd: selectProduct.cmpCd,
                brandCd: selectProduct.brandCd,
                nationCd: selectNationCd,
                productCd: selectProduct.productCd,
                productNm: selectProductInfo.productNm,
                instUser: selectProduct.instUser ? selectProduct.instUser : user.userId,
                updUser: user.userId,
            }
            delete productInfo.instTime;
            delete productInfo.updTime;

            console.log(">>> params :: ", productInfo);

            setLoading(true);
            insertCkProductInfo(productInfo).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    // search();
                } else {
                    setError({visible: true, message: responseMessage});
                }
            })
                .catch((e) => {
                    setError({visible: true, message: e.message});
                })
                .finally(() => {
                    setLoading(false);
                })
        }
    }

    const getProductInfoOne = (productCd, nationCd) => {
        const params = {
            productCd: productCd,
            nationCd: nationCd
        };
        setLoading(true);
        getCkProductInfoOne(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                // 성공
                if (responseBody === null) {
                    setSelectProductInfo({productNm: "", origin: "", nutrient: "", nationCd: "US"});
                }
                else {
                    setSelectProductInfo(responseBody);
                }
            } else {
                setError({visible: true, message: responseMessage});
            }
        })
            .catch((e) => {
                setError({visible: true, message: e.message});
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const onRowSelected = useCallback((event) => {
        if (!event.node.selected)
            return;

        // 이전 값 초기화
        setSelectProductInfo({productNm: "", origin: "", nutrient: "", nationCd: "US"});

        const data = event.node.data;
        setSelectProduct(data);
        setSelectNationCd("US");
        getProductInfoOne(data.productCd, "US");
    }, []);

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}

                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                    <h5>상품 다국어관리</h5>
                </div>

                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                    <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                                    onSelect={(c, v) => handleSelect(c, v)}/>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
                            <CFormInput id="productCd"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                restProductCd: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                            <CFormInput id="productNm"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                productNm: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CButton size={"sm"} onClick={search}>조회</CButton>
                    </CCol>
                </CForm>

                <div style={{height: 10}}/>
                <CRow>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            <strong>상품목록</strong>
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
                            <AgGridReact
                                ref={gridRef}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={gridData}
                                animateRows={true}
                                rowSelection={'single'}
                                onRowSelected={onRowSelected}
                                defaultColDef={defaultColDef}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                    <CCol xs={6}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            <strong>상품목록</strong>
                        </div>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>상품코드</strong></CInputGroupText>
                            <CFormInput id="restProductCd"
                                        value={selectProduct.restProductCd}
                                        disabled={true}/>
                        </CInputGroup>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>한글 상품명</strong></CInputGroupText>
                            <CFormInput id="productNm"
                                        value={selectProduct.productNm}
                                        disabled={true}/>
                        </CInputGroup>
                        <div style={{
                            borderRadius: 5,
                            padding: 10,
                            marginTop: 10,
                            marginBottom: 10,
                            background: "#87CEFA"
                        }}>
                            <strong>언어별 설정</strong>
                        </div>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>언어</strong></CInputGroupText>
                            <CFormSelect value={selectNationCd}
                                         onChange={(e) => {
                                             setSelectNationCd(e.target.value);
                                             setSelectProductInfo((state) => ({
                                                 ...state,
                                                 nationCd: e.target.value
                                             }));

                                             // 다국어 상품값 호출
                                             getProductInfoOne(selectProduct.productCd, e.target.value);
                                         }}>
                                <option value={"US"}>영어</option>
                                <option value={"JP"}>일본어</option>
                                <option value={"CN"}>중국어</option>
                            </CFormSelect>
                        </CInputGroup>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>다국어 상품명</strong></CInputGroupText>
                            <CFormInput id="productNm"
                                        value={selectProductInfo.productNm}
                                        onChange={(e) => {
                                            setSelectProductInfo((state) => ({
                                                ...state,
                                                productNm: e.target.value
                                            }))
                                        }}/>
                        </CInputGroup>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>상품설명</strong></CInputGroupText>
                            <CFormInput id="nutrient"
                                        value={selectProductInfo.nutrient}
                                        onChange={(e) => {
                                            setSelectProductInfo((state) => ({
                                                ...state,
                                                nutrient: e.target.value
                                            }))
                                        }}/>
                        </CInputGroup>
                        <CInputGroup className={"mb-1"} size={"sm"}>
                            <CInputGroupText style={{width: 100}}><strong>원산지</strong></CInputGroupText>
                            <CFormInput id="origin"
                                        value={selectProductInfo.origin}
                                        onChange={(e) => {
                                            setSelectProductInfo((state) => ({
                                                ...state,
                                                origin: e.target.value
                                            }))
                                        }}/>
                        </CInputGroup>

                        <div className={"d-grid"} style={{marginTop: 10}}>
                            <CButton onClick={save}>저장</CButton>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductLanguage);
